import React from 'react';
import { platformTexts } from '../contexts/LangHO2';
import winserverImg from '../assets/images/halcyon/winserver.png';
import windowsImg from '../assets/images/halcyon/windows.png';
import linuxImg from '../assets/images/halcyon/linux.png';

function ProductHOPlatform2({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        // background: '#0066CC',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {/* 제목 */}
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 20 : 30,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        width: '100%'
      }}>
        {platformTexts.title[lang]}
      </span>
      
      {/* 콘텐츠 영역 - 이미지 3개만 표시 */}
      <div style={{
        width: '100%',
        padding: isMobile ? '0 20px 40px 20px' : '0 40px 40px 40px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 40 : 60,
        maxWidth: '1200px',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {/* 첫 번째 이미지 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img
            src={winserverImg}
            alt="AI Technology"
            style={{
              width: isMobile ? 120 : 150,
              height: isMobile ? 120 : 150,
              objectFit: 'contain'
            }}
          />
        </div>

        {/* 두 번째 이미지 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img
            src={windowsImg}
            alt="Cloud Native"
            style={{
              width: isMobile ? 120 : 150,
              height: isMobile ? 120 : 150,
              objectFit: 'contain'
            }}
          />
        </div>

        {/* 세 번째 이미지 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img
            src={linuxImg}
            alt="Zero Trust"
            style={{
              width: isMobile ? 120 : 150,
              height: isMobile ? 120 : 150,
              objectFit: 'contain'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductHOPlatform2;